export { default as Home } from "./Home.js";
export { default as DataPage } from "./DataPage.js";
export { default as Portfolio } from "./Portfolio.js";
export { default as Resume } from "./Resume.js";
export { default as History } from "./History.js";
